import { ProcessingJobStatus, type Job } from "store/jobsStore";
import { ImportTargetsEnum } from "types";

export const isInterforumEdiJobInProgress = (job: Job): boolean =>
    job.importType === ImportTargetsEnum.processInterforumEdi &&
    (job.status === ProcessingJobStatus.PROCESSING || job.status === ProcessingJobStatus.QUEUED);

export const getInterforumEdiJobsInProgress = (jobs: Job[]): Job[] => jobs.filter(isInterforumEdiJobInProgress);

export const countInterforumEdiJobsInProgress = (jobs: Job[]): number => getInterforumEdiJobsInProgress(jobs).length;
